module.exports = __webpack_public_path__ + "img/map.5e48a1e0.png";